module.exports = __webpack_public_path__ + "static/media/restaurant-menu-template.0b112450.xlsx";